<template lang="pug">
validation-observer(ref="observer" tag="div")
  .conteudo(v-if="!loading")
    validation-provider(:rules="resposta.anexoList && resposta.anexoList.length > 0 ? '' : 'required'", v-slot="{ errors }" name="conteudo")
      app-text-editor.input(
        :class="{'erro': errors && errors.length}"
        v-model="conteudoReposta"
        :value="conteudoReposta",
        ref="editorTexto"
      )
      span.erro.help(v-if="errors && errors.length") Para enviar uma resposta, informe uma mensagem ou anexe um arquivo.

    .anexo(v-if="showAnexos")
      h4 Anexos mensagem
      validation-provider(:rules="resposta.conteudo ? '' : 'required'",  name="anexo" v-slot="{ errors }")
        app-anexo(
          :id="'upload-resposta-solicitacao'"
          @removeFile="removeFile",
          @uploadFile="uploadFile",
          :files="resposta.anexoList",
          scope="anexos",
          v-model="resposta.anexoList",
          @downloadDocumentoCadastro="download",
          :errors="errors"
          :maxSize="1024"
        )
        span.erro.help(v-if="errors && errors.length") Para enviar uma resposta, informe uma mensagem ou anexe um arquivo.
    .buttons
      el-button(
        type="default",
        @click="$router.push({ name: 'caixa-entrada' })"
      ) Cancelar
      el-button(
        type="primary",
        @click="enviarResposta",
      ) Enviar
</template>

<script>
import AppTextEditor from '@/components/AppTextEditor'
import AppAnexo from '@/components/AppAnexo'
import FileHelper from '@/utils/fileHelper'
import { mapGetters, mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
const { sendMessageToReoplay } = require('@/utils/' +
  process.env.ESTADO +
  '/regrasCentral').default

export default {
  mixins: [AppNotificacao],

  components: {
    AppTextEditor,
    AppAnexo
  },

  props: {
    showAnexos: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data () {
    return {
      respondido: false,
      loading: false
    }
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),
    resposta () {
      return this.$store.getters['conversas/resposta']
    },

    tiposDocumentos () {
      return this.$store.getters['conversas/tipoDocumento']
    },

    conteudoReposta: {
      get () {
        return this.resposta.conteudo
      },
      set (val) {
        this.$store.commit('conversas/SET_RESPOSTA_CONTEUDO', val)
      }
    }
  },

  methods: {
    ...mapActions({
      downloadDocumentos: 'download/downloadDocument'
    }),
    cancelar () {
      this.$router.push({
        name: 'caixa-entrada'
      })
    },

    async download (anexo) {
      const arquivo = await this.downloadDocumentos(anexo)
      FileHelper.saveFile(arquivo, anexo.nome)
    },
    anexar () {
      this.$emit('anexar')
    },
    close () {
      this.$emit('close')
    },

    enviarResposta () {
      sendMessageToReoplay(this.confirmBox, this.$messages.EXTERNO_RESPONDER_CONVERSA_PA, this.$messages.TITULO_WARNING, this.enviar)
    },

    async enviar () {
      if (this.showAnexos) {
        const valid = await this.$refs.observer.validate()

        if (!valid) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            'Verifique os campos destacados.'
          )
          return
        }
      } else {
        this.anexar()
        if (this.resposta.anexoList.length === 0 || this.resposta.anexoList.length !== this.tiposDocumentos.length) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            'Verifique os anexos'
          )
          return
        }
      }

      this.loading = true

      await this.$store.dispatch('conversas/sendMensagensProcesso', this.resposta).then(() => {
        this.$store.dispatch('conversas/read', {
          idConversa: this.resposta.conversa.id,
          idUsuario: this.usuario.id,
          idPessoa: this.usuario.pessoa.id
        })
      })

      this.$refs.observer.reset()
      this.$store.dispatch('conversas/clearResposta')
      this.loading = false
      if (!this.showAnexos) {
        this.close()
      }
      this.$emit('mensagemRespondida')
    },

    uploadFile (file) {
      this.$store.commit('conversas/ADD_ANEXO', { key: file.response, nome: file.name })
    },

    removeFile (file) {
      this.$store.commit('conversas/REMOVE_ANEXO', file)
    }
  }

}
</script>

<style lang="scss" scoped>
  .conteudo {
    margin: 40px 15px;
    text-align: left;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    color: #2c3e50;
  }

  .buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }

  .anexo {
    padding: 15px 0;
  }

</style>



// WEBPACK FOOTER //
// src/screens/central/components/centralMensagens/AppResposta.vue